import { useMemo } from "react";
import { useV2ListCollaboratorsForAccountQuery } from "@generated";

// Collaborators are Users (collaborator.id === user.id), used to pick which
// user becomes a service approver.
export const useCollaboratorOptions = () => {
  const { data } = useV2ListCollaboratorsForAccountQuery({
    filter: { active: true },
    page: { size: 500 },
  });

  return useMemo(() => {
    const list = (data?.data ?? []).map((c: any) => ({
      value: String(c.id),
      label: c.attributes?.name ?? "",
    }));
    const nameById: Record<string, string> = {};
    list.forEach((o) => (nameById[o.value] = o.label));
    return { options: list, nameById };
  }, [data]);
};

export default useCollaboratorOptions;
